<template>
  <!-- -->
  <div>
    <div class="member-service">
      <div class="title">
        <div :style="{'color': settingData.textColor, 'font-size': settingData.textSize}">{{settingData.text}}</div>
      </div>
      <div class="service-list">
        <div class="service-item" v-for="item in serviceList" :key="item.name" :style="{'color': item.color}">
          <yq-icon :name="item.icon" class="service-item"/>
          <div class="service-name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="member-service-list">
      <div class="title" :style="{'margin': data.componentMargin}">
        <div :style="{'color': settingData.textColor, 'font-size': settingData.textSize}">{{settingData.text}}</div>
      </div>
      <div class="service-list">
        <div class="service-item" v-for="item in serviceList" :key="item.name" :style="{'color': item.color,'margin': data.componentMargin, 'background-color': data.componentBackground, 'background-image': `url(${getImageUrl(data.componentBackgroundImage)})`, 'background-repeat': 'no-repeat','background-size': 'cover', 'border-radius': `${item.radius}px`}">
          <yq-icon :name="item.icon" class="service-icon"/>
          <div class="service-name">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";
import ImageUtil from "@/util/imageUtil";
export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    YqIcon, AloneTextOnImage, AloneImage
  },
  data() {
    return {
      settingData: {},
      serviceList: [
        {icon: "kefu", name: "我的客服", color: "#FF6B35"},
        {icon: "shouhou", name: "联系售后", color: "#FFCC00"},
        {icon: "element-ui_s-marketing", name: "生产进度", color: "#00C851"},
        {icon: "shoucangwujiaoxing", name: "我的评价", color: "#0099CC"},
        {icon: "dingdanguanli", name: "我的报修", color: "#AA00FF"},
        {icon: "element-ui_video-camera-solid", name: "使用视频", color: "#FF0080"},
        {icon: "huiyuanqiagoumai", name: "质保卡片", color: "#FF3B30"},
        {icon: "dingwei2", name: "地址管理", color: "#FF9500"}
      ]
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {text: "我的服务"};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    // 获取图片的url
    getImageUrl(url) {
      return ImageUtil.getFileUrlSingle(url);
    },
  }
};
</script>

<style lang="scss" scoped>
.member-service {
  padding: 30px;
  .title{
    font-size: 28px;
    font-weight: 500;
  }
  .image{
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  .service-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);  /* 每行4列，均匀分配宽度 */
    justify-items: center;                    /* 水平居中对齐 */
    gap: 50px 0;                             /* 行间距20px */
    margin-top: 30px;

    .service-item {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .service-name{
      font-size: 22px;
      color: var(--yq-font-color-desc);
      margin-top: 30px;
    }
  }
}
.member-service-list {
  background: none !important;
  margin: 0 !important;
  .title{
    font-size: 28px;
    font-weight: 500;
  }
  .image{
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  .service-list {
    .service-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 20px;
      margin-bottom: 20px;
      &:last-child{
        margin-bottom: 0;
      }
      .service-icon{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        width: 40px;
        height: 40px;
      }
    }
    .service-name{
      font-size: 22px;
      color: var(--yq-font-color-desc);
    }
  }
}
</style>